module.exports = __webpack_public_path__ + "img/bg1.95460518.png";